import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";
import { API_BASE_URL } from "../config/apiConfig";

export const SessionExpirationPopup = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [countdown, setCountdown] = useState(10);
    const location = useLocation();

    // Logout logic (inline here, updates stats + clears session)
    const logout = async () => {
        try {
            const token = localStorage.getItem("token");
            const sessionStart = localStorage.getItem("sessionStart"); // saved at login/start
            const sessionEnd = new Date().toISOString(); // current time as logout

            if (token && sessionStart) {
                // Send sessionStart and sessionEnd to backend to record session duration
                await fetch(`${API_BASE_URL}/api/users/update-hours`, {
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        sessionStart,
                        sessionEnd,
                    }),
                });
            }
        } catch (error) {
            console.error("Error updating user stats on logout:", error);
        } finally {
            // Clear localStorage and redirect
            localStorage.removeItem("token");
            localStorage.removeItem("sessionStart");
            window.location.href = "/login";
        }
    };


    // Check token validity on mount + interval
    useEffect(() => {
        const checkTokenValidity = () => {
            const token = localStorage.getItem("token");

            if (!token) {
                setShowPopup(true);
                return;
            }

            try {
                const decoded = jwtDecode(token);
                const currentTime = Math.floor(Date.now() / 1000);

                if (decoded.exp < currentTime) {
                    setShowPopup(true);
                }
            } catch (error) {
                console.error("Invalid token:", error);
                setShowPopup(true);
            }
        };

        // Skip popup on public routes
        // Skip popup on public routes
        const publicRoutes = [
            "/login",
            "/register",
            "/",
            "/onboarding",
            "/forgot-password",
            "/otp",
            "/reset-password",
            "/reset-otp",
            "/signup",
            "/features",
            "/contact-us",
            "/about",
            "/subjects",
            "/pricing",
            "/testimonials",
            "/group-invite",
            "/group-invite/accept",
            "/group-invite/reject",
        ];

        const isPublicRoute = publicRoutes.some(route =>
            location.pathname.startsWith(route)
        );

        if (isPublicRoute) {
            setShowPopup(false);
            return;
        }

        checkTokenValidity();
        const interval = setInterval(checkTokenValidity, 60 * 1000);

        return () => clearInterval(interval);
    }, [location.pathname]);

    // Countdown + auto logout
    useEffect(() => {
        if (!showPopup) return;

        setCountdown(10); // reset countdown when popup shows
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    logout();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [showPopup]);

    if (!showPopup) return null;

    return (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="bg-white p-5 rounded shadow-lg text-center">
                <h2 className="text-lg font-semibold">Your session has expired</h2>
                <p>You will be logged out in {countdown} seconds.</p>
                <button
                    onClick={logout}
                    className="mt-4 px-4 py-2 bg-blue-500 text-white rounded"
                >
                    Re-Login Now
                </button>
            </div>
        </div>
    );
};
